import React, { useEffect, useRef } from "react";

function MicOffIcon({ className = "h-[60px] w-[60px]" }) {
  return (
    <svg className={className} viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <path
        d="M22.4998 17.8334V14.1667C22.4998 12.786 21.3805 11.6667 19.9998 11.6667C19.0185 11.6667 18.1692 12.2322 17.76 13.055M19.9998 25.8334V28.3334M19.9998 25.8334C16.7782 25.8334 14.1665 23.2217 14.1665 20.0001V18.3334M19.9998 25.8334C23.2215 25.8334 25.8332 23.2217 25.8332 20.0001V18.3334M16.6665 28.3334H23.3332M11.6665 11.6667L28.3332 28.3334M19.9998 22.5001C18.6191 22.5001 17.4998 21.3808 17.4998 20.0001V17.5001L21.7687 21.7668C21.3162 22.2198 20.6907 22.5001 19.9998 22.5001Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MicOnIcon({ className = "h-[60px] w-[60px]" }) {
  return (
    <svg className={className} viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <path
        d="M20 24.1667C22.3012 24.1667 24.1667 22.3012 24.1667 20V13.3334C24.1667 11.0322 22.3012 9.16669 20 9.16669C17.6988 9.16669 15.8333 11.0322 15.8333 13.3334V20C15.8333 22.3012 17.6988 24.1667 20 24.1667ZM20 24.1667V28.3334M16.6667 28.3334H23.3333M12.5 20V21.6667C12.5 25.8088 15.8579 29.1667 20 29.1667C24.1421 29.1667 27.5 25.8088 27.5 21.6667V20"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function HangupIcon() {
  return (
    <svg className="h-[60px] w-[60px]" viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <path
        d="M14.5629 20.7193C13.7037 19.3853 13.0637 17.9511 12.6427 16.4679C12.5092 15.9975 12.4424 15.7623 12.4414 15.4182C12.4403 15.0363 12.5747 14.5193 12.7618 14.1863C12.9303 13.8863 13.151 13.6656 13.5923 13.2243L13.7237 13.0929C14.1666 12.65 14.388 12.4286 14.6258 12.3083C15.0988 12.0691 15.6573 12.0691 16.1303 12.3083C16.3681 12.4286 16.5896 12.65 17.0324 13.0929L17.1948 13.2553C17.4862 13.5466 17.6318 13.6923 17.7271 13.8388C18.0862 14.3912 18.0862 15.1034 17.7271 15.6558C17.6318 15.8022 17.4862 15.9479 17.1948 16.2393C17.0996 16.3345 17.0519 16.3821 17.0121 16.4378C16.8704 16.6357 16.8215 16.9226 16.8896 17.1562C16.9087 17.2219 16.9337 17.2739 16.9836 17.3778C17.0843 17.5875 17.1913 17.795 17.3047 17.9998M19.3181 20.6817L19.3555 20.7193C20.3568 21.7206 21.4891 22.5113 22.6971 23.0913C22.801 23.1412 22.8529 23.1661 22.9187 23.1853C23.1523 23.2534 23.4392 23.2045 23.637 23.0628C23.6927 23.0229 23.7403 22.9753 23.8356 22.88C24.1269 22.5887 24.2726 22.443 24.4191 22.3478C24.9715 21.9886 25.6837 21.9886 26.2361 22.3478C26.3825 22.443 26.5282 22.5887 26.8196 22.88L26.9819 23.0424C27.4248 23.4853 27.6462 23.7067 27.7665 23.9446C28.0058 24.4175 28.0058 24.9761 27.7665 25.449C27.6462 25.6869 27.4248 25.9083 26.9819 26.3512L26.8506 26.4825C26.4092 26.9239 26.1886 27.1446 25.8885 27.3131C25.5556 27.5001 25.0385 27.6346 24.6567 27.6334C24.3126 27.6324 24.0774 27.5657 23.607 27.4322C21.0792 26.7147 18.6939 25.361 16.7039 23.371L16.6665 23.3334M27.4997 12.5001L12.4997 27.5001"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function FullscreenEnterIcon() {
  return (
    <svg className="h-[60px] w-[60px]" viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <path
        d="M14.1667 9.16669H9.16675V14.1667M25.8334 9.16669H30.8334V14.1667M14.1667 30.8334H9.16675V25.8334M25.8334 30.8334H30.8334V25.8334"
        stroke="white"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8333 15.8333L9.16663 9.16663M24.1666 15.8333L30.8333 9.16663M15.8333 24.1666L9.16663 30.8333M24.1666 24.1666L30.8333 30.8333"
        stroke="white"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function FullscreenExitIcon() {
  return (
    <svg className="h-[60px] w-[60px]" viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <path
        d="M15 9.16669H9.16663V15M25 9.16669H30.8333V15M15 30.8334H9.16663V25M25 30.8334H30.8333V25"
        stroke="white"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8333 15.8333H9.16663M15.8333 15.8333V9.16663M24.1666 15.8333H30.8333M24.1666 15.8333V9.16663M15.8333 24.1666H9.16663M15.8333 24.1666V30.8333M24.1666 24.1666H30.8333M24.1666 24.1666V30.8333"
        stroke="white"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function VideoLayout({
  localStream,
  remoteStream,
  onLeave,
  onToggleMute,
  onToggleFullscreen,
  isMicMuted,
  isFullscreen,
  remoteMute,
  subtitleText,
  timerLabel,
  timerVariant = "default",
  uiState,
  controlsDisabled = false,
}) {
  const localVideoRef = useRef(null);
  const remoteVideoRef = useRef(null);

  useEffect(() => {
    if (!localVideoRef.current) {
      return;
    }
    localVideoRef.current.srcObject = localStream || null;
  }, [localStream]);

  useEffect(() => {
    if (!remoteVideoRef.current) {
      return;
    }
    remoteVideoRef.current.srcObject = remoteStream || null;
  }, [remoteStream]);

  const timerClassName =
    timerVariant === "danger"
      ? "bg-[#DC2626] shadow-[0_0_0_3px_rgba(248,113,113,0.35)]"
      : timerVariant === "warning"
        ? "bg-[#D97706] shadow-[0_0_0_3px_rgba(251,191,36,0.35)]"
        : "bg-[#045DE8]";

  return (
    <div className="relative h-[55vh] min-h-[360px] flex-1 overflow-hidden rounded-2xl shadow-[0_0_34px_rgba(4,93,232,0.14)] lg:h-auto">
      {remoteStream ? (
        <video
          ref={remoteVideoRef}
          autoPlay
          playsInline
          className="h-full w-full bg-black object-cover"
        />
      ) : (
        <div className="flex h-full w-full items-center justify-center bg-[#1d2a36] px-6 text-center text-sm text-white/90">
          Waiting for remote video stream...
        </div>
      )}

      <div className="absolute left-[18px] top-[18px] flex items-center gap-2">
        <div
          className={`h-10 rounded-[40px] px-[14px] py-2 text-sm font-semibold text-white transition-colors ${timerClassName}`}
        >
          {timerLabel}
        </div>
        <span
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-black/55 text-white backdrop-blur-[4px]"
          title={`Participant microphone ${remoteMute ? "muted" : "unmuted"}`}
          aria-label={`Participant microphone ${remoteMute ? "muted" : "unmuted"}`}
        >
          {remoteMute ? (
            <MicOffIcon className="h-8 w-8 shrink-0" />
          ) : (
            <MicOnIcon className="h-8 w-8 shrink-0" />
          )}
        </span>
      </div>

      <div className="absolute right-[18px] top-[18px] h-[95px] w-[140px] overflow-hidden rounded-xl border border-[#045DE8] bg-black sm:h-32 sm:w-48">
        <video
          ref={localVideoRef}
          autoPlay
          playsInline
          muted
          className="h-full w-full object-cover"
        />
      </div>

      <div className="absolute hidden bottom-[100px] left-1/2 min-w-[85%] max-w-[90%] -translate-x-1/2 rounded-xl bg-black/50 px-6 py-3 text-center text-[13px] text-white sm:text-sm">
        {subtitleText || `Interview status: ${uiState}`}
      </div>

      <div className="absolute bottom-0 left-0 flex h-[76px] w-full items-center justify-center gap-[11px] bg-white/40 backdrop-blur-[7px]">
        <button
          type="button"
          onClick={onToggleMute}
          disabled={controlsDisabled}
          className={`flex h-[60px] w-[60px] items-center justify-center rounded-[50px] border-none ${
            controlsDisabled
              ? "cursor-not-allowed bg-[#7da9f0]/80"
              : "cursor-pointer bg-[#045DE8]"
          }`}
          title={isMicMuted ? "Unmute microphone" : "Mute microphone"}
        >
          {isMicMuted ? <MicOffIcon /> : <MicOnIcon />}
        </button>
        <button
          type="button"
          onClick={onToggleFullscreen}
          className="flex h-[60px] w-[60px] cursor-pointer items-center justify-center rounded-[50px] border-none bg-[#0F766E]"
          title={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
        >
          {isFullscreen ? <FullscreenExitIcon /> : <FullscreenEnterIcon />}
        </button>
        <button
          type="button"
          onClick={onLeave}
          className="flex h-[60px] w-[60px] cursor-pointer items-center justify-center rounded-[50px] border-none bg-[#ED2323]"
          title="Leave interview"
        >
          <HangupIcon />
        </button>
      </div>
    </div>
  );
}
